// SupplieGrid.jsx
import { useState, useCallback, useMemo } from "react"
import { Box, Grid, Typography, CircularProgress } from "@mui/material"
import { SupplieCard } from "./SupplieCard"
import { SupplieSearchBar } from "./SupplieSearchBar"
import { useSupplies } from "../hooks/useSupplies"
import { useEffect } from "react"

export const SupplieGrid = ({ selectedSupplies, setSelectedSupplies }) => {


  const { supplies, loading, error, fetchSupplies } = useSupplies()

  useEffect(() => {
    fetchSupplies()
  }, [])
  

  const [searchTerm, setSearchTerm] = useState("")

  const handleSelect = useCallback(
    (supply) => {
      setSelectedSupplies((prev) => {
        const exists = prev.some((item) => item.id === supply.id)
        if (exists) {
          return prev.filter((item) => item.id !== supply.id)
        }
        return [
          ...prev,
          {
            id: supply.id,
            price: parseFloat(supply.price),
            quantity: 1,
            name: supply.name,
            type: supply.type,
          },
        ]
      })
    },
    [setSelectedSupplies]
  )

  const handlePriceChange = 
    (id, newValue) => {
      setSelectedSupplies((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, price: parseFloat(newValue) }
            : item
        )
      )
    }

  const handleSearch = (term) => {
    setSearchTerm(term)
  }

  const displayedSupplies = useMemo(() => {
    if (!searchTerm) return supplies
    const lowerTerm = searchTerm.toLowerCase()
    return supplies.filter((s) =>
      s.name.toLowerCase().includes(lowerTerm)
    )
  }, [supplies, searchTerm])

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", color: "error.main", py: 4 }}>
        <Typography>Failed to load supplies.</Typography>
      </Box>
    )
  }

  return (
    <Box>
      <SupplieSearchBar supplies={supplies} onSearch={handleSearch} />

      {displayedSupplies.length === 0 && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <Typography>No products found.</Typography>
        </Box>
      )}

      {displayedSupplies.length > 0 && (
        <Grid container spacing={2}>
          {displayedSupplies.map((supply) => (
            <Grid item xs={12} sm={6} md={4} key={supply.id}>
              <SupplieCard
                supply={supply}
                selectedSupplies={selectedSupplies}
                onSelect={handleSelect}
                onPriceChange={handlePriceChange}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  )
}
